export const Events = {
  install (_Vue) {
    if (!('$events' in _Vue.prototype)) {
      Object.defineProperty(_Vue.prototype, '$events', {
        get () {
          return this.$root._events;
        },
      });

      _Vue.mixin({
        beforeCreate () {
          if (this.$options.events !== undefined) {
            this._events = this.$options.events;
          }
        },
      });
    }
  },
};
